import React from 'react'

const EllipseSVG: React.FC = () => {
    return (
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 40 40">
            <ellipse
                fill={'none'}
                stroke={'#000'}
                strokeWidth={2}
                strokeMiterlimit={10}
                cx={20}
                cy={20}
                rx={17}
                ry={13}
            />
        </svg>
    )
}

export default EllipseSVG
